import { PreRegisterType } from '../../@types';
import api from '../api';

export async function CreatePreRegister(data: PreRegisterType) {
	return await api.post(`/api/v1/pre-register-company`, data);
}
